( function( app ) {
  const COMPONENT = {
    init: function() {
      let currentTab = $( '.floor-plans' ).find( '.floor-plans-tabs__tab-panel.is-open' ).attr( 'id' );
      $( document ).on( 'change', '.js-floor-plans-tabs__form', function( event ) {
        event.preventDefault();
        const formData = $( this ).serializeArray();

        let updatedTab = null;
        let inputType = '';
        $( formData ).each( function( index, value ) {
          if ( value.value !== currentTab ) {
            updatedTab = value.value;
            inputType = value.name;
          }
        } );

        /* Show the new panel and update aria/inert attributes */
        $( `#${currentTab}` ).removeClass( 'is-open' ).attr( 'aria-hidden', 'true' ).attr( 'inert', '' );
        $( `#${updatedTab}` ).addClass( 'is-open' ).attr( 'aria-hidden', 'false' ).removeAttr( 'inert' );

        currentTab = updatedTab;

        /* make sure form fields have same value */
        if ( inputType === 'floor-plans-item-select' ) {
          $( '.floor-plans' ).find( `.floor-plans__radio-input[value="floor-plans-tabs-tab-${currentTab}"]` ).prop( 'checked', true );
        } else {
          $( '.floor-plans select' ).val( currentTab );
        }

        const announcement = $( '.floor-plans' ).find( '.floor-plans-tabs__announcement' );
        /* announce which panel is now visible */
        const selectedTitle = $( `.floor-plans__radio-input[value="${updatedTab}"] ~ label .hdg-6` ).text().trim();
        if ( selectedTitle ) {
          announcement.text( `${selectedTitle} is now displayed` );
        }

        return false;
      } );
    },
    finalize: function() {
      $( document ).on( 'click', '[data-floor-plans-gallery]', function() {
        const items = JSON.parse( $( this ).attr( 'data-floor-plans-gallery' ) || '[]' );
        if ( !items.length ) return;

        $.magnificPopup.open( {
          items: items.map( function( item ) {
            return {src: item.src, title: item.title, type: 'image'};
          } ),
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="sr-only">%title%</span></button>',
            tPrev: 'Previous image',
            tNext: 'Next image',
            tCounter: 'Image %curr% of %total%',
          },
          type: 'image',
          image: {
            titleSrc: 'title',
            tError: '<a href="%url%">The image</a> could not be loaded.',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: true,
          closeBtnInside: false,
          closeOnContentClick: false,
          callbacks: {
            open: function() {
              // Move focus into popup for ADA
              $( '.mfp-wrap' ).attr( 'aria-modal', 'true' ).attr( 'role', 'dialog' ).attr( 'aria-label', 'Image gallery' );
            },
          },
        } );
      } );
    },
  };

  app.registerComponent( 'floor-plans', COMPONENT );
} )( app );
